<template lang="pug">
  .modal--close
    .modal--close-btn
      span.modal--close-desktop
        i.fas.fa-times
      span.modal--close-mobile.text--size_14
        | {{ text }}
</template>


<script>
  export default {
    props: {
      text: {
        type: String,
        default: 'Close Popup',
      },
    },

    name: 'ModalClose',  
  }
  
</script>



<style lang="scss">

</style>